import React, { useState, useEffect } from 'react';
import AssetWorkflow from './annotation-layer/AssetWorkflow'; // Import the AssetWorkflow component
import { warmupAudio, playClick } from '../audio/clicks'; // ← add this (adjust path if needed)

// Try Firebase SDK first; fall back to public URL if unavailable
let storageFns = null;
try {
  const { getStorage, ref, getDownloadURL } = require('firebase/storage');
  storageFns = { getStorage, ref, getDownloadURL };
} catch (_) {
  storageFns = null;
}

function AssetSOPforms() {
  const [sessionStarted, setSessionStarted] = useState(false);
  const [selectedType, setSelectedType] = useState(null); // resolved URL

  // 🔊 Unlock audio on first user gesture
  useEffect(() => {
    const unlock = () => {
      warmupAudio();
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('keydown', unlock);
    };
    window.addEventListener('pointerdown', unlock, { once: true });
    window.addEventListener('keydown', unlock, { once: true });
  }, []);

  // Tiny helper to inject click sound, skipping disabled/aria-disabled
  const withClick = (fn) => (e) => {
    if (e?.currentTarget?.disabled || e?.currentTarget?.getAttribute('aria-disabled') === 'true') return;
    playClick();
    return fn?.(e);
  };

  const startSession = () => setSessionStarted(true);

  // ===== Firebase path config (matches your example) =====
  const BUCKET = 'xrpdf-3e5d1.appspot.com';
  const FORMS_PREFIX = 'xr_assets'; // e.g., xr_assets/FORM2.xml

  // Optional tokens for public fallback (only needed if the object requires a token)
  const TOKEN_MAP = {
    2: 'ce3488d6-a06d-4ccc-ae2f-cf14582be069', // your FORM2 token
    // 1: '<token-for-FORM1>',
    // 3: '<token-for-FORM3>',
    // ...
  };

  const buildPublicUrl = (n) => {
    const objectPath = `${FORMS_PREFIX}/FORM${n}.xml`;
    const encoded = encodeURIComponent(objectPath);
    const base = `https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o/${encoded}?alt=media`;
    const token = TOKEN_MAP[n];
    return token ? `${base}&token=${token}` : base;
  };

  const resolveFormUrl = async (n) => {
    const objectPath = `${FORMS_PREFIX}/FORM${n}.xml`;

    // Prefer SDK (no token headaches)
    if (storageFns) {
      const { getStorage, ref, getDownloadURL } = storageFns;
      const storage = getStorage();
      const fileRef = ref(storage, objectPath);
      return await getDownloadURL(fileRef);
    }

    // Fallback: public REST URL
    return buildPublicUrl(n);
  };

  // Function to handle button click and select type
  const showSubForm = async (option) => {
    try {
      const formUrl = await resolveFormUrl(option);
      setSelectedType(formUrl);
      startSession();
    } catch (err) {
      // Last-ditch fallback to public URL even if SDK path failed
      setSelectedType(buildPublicUrl(option));
      startSession();
    }
  };

  return (
    <div>
      <h2>Standard Operating Procedures Library</h2>

      {/* ⚠️ No layout/style changes below this line */}
      <div id="menu">
        <button onClick={withClick(() => showSubForm(1))}>Form 1</button>
        <button onClick={withClick(() => showSubForm(2))}>Form 2</button>
        <button onClick={withClick(() => showSubForm(3))}>Form 3</button>
        <button onClick={withClick(() => showSubForm(4))}>Form 4</button>
        <button onClick={withClick(() => showSubForm(5))}>Form 5</button>
        <button onClick={withClick(() => showSubForm(6))}>Form 6</button>
        <button onClick={withClick(() => showSubForm(7))}>Form 7</button>
        <button onClick={withClick(() => showSubForm(8))}>Form 8</button>
        <button onClick={withClick(() => showSubForm(9))}>Form 9</button>
        <button onClick={withClick(() => showSubForm(10))}>Form 10</button>
      </div>

      {/* Render AssetWorkflow for the selected type */}
      {selectedType && <AssetWorkflow formUrl={selectedType} />}
    </div>
  );
}

export default AssetSOPforms;
